import {Medal} from './leaderboardTheme';

export type Period = 'daily' | 'weekly';

export type TrendDir = 'up' | 'down' | 'flat';

// One ranked player as delivered by the data source (mock engine or API).
// trend/trendDelta are the server's since-yesterday movement when available
// (live mode); the mock engine omits them and useLeaderboardData falls back to
// a session-relative baseline.
export interface LeaderboardEntry {
  userid: number;
  rank: number;
  name: string;
  rating: number;
  wins: number;
  avatarUrl?: string;
  you?: boolean;
  trend?: TrendDir;
  trendDelta?: number | null;
}

// The signed-in player's own standing (may sit outside the returned top list).
export interface MeEntry {
  // null ⇒ no wins in the window yet, hence unranked.
  rank: number | null;
  wins: number;
  rating: number;
  name: string;
  avatarUrl?: string;
  inTop: boolean;
  trend?: TrendDir;
  trendDelta?: number | null;
}

// A full snapshot of one period's board.
export interface LeaderboardSnapshot {
  period: Period;
  entries: LeaderboardEntry[];
  me: MeEntry;
  totalPlayers: number;
  leaderWins: number;
}

// Entry decorated with presentation state by useLeaderboardData.
export interface LeaderboardRowVM extends LeaderboardEntry {
  initials: string;
  color: string;
  medal: Medal | null;
  barPct: number;
  flash: boolean;
  trend: 'up' | 'down' | 'flat';
  trendAbs: number | null;
}

export interface MeVM extends MeEntry {
  initials: string;
  trend: 'up' | 'down' | 'flat';
  trendAbs: number | null;
  // Wins needed to overtake the player one rank above (0 when leader/unranked).
  toNext: number;
  nextLabel: string;
  winsToEnterTop: number;
}

export interface PeriodMeta {
  key: Period;
  label: string;
  word: string;
  winWord: string;
}

export const PERIODS: PeriodMeta[] = [
  {key: 'daily', label: 'Daily', word: 'day', winWord: 'today'},
  {key: 'weekly', label: 'Weekly', word: 'week', winWord: 'this week'},
];

export const periodMeta = (key: Period): PeriodMeta =>
  PERIODS.find(p => p.key === key) || PERIODS[0];
